<template>
  <v-navigation-drawer
    v-model="drawer"
    class="work-navigation-drawer"
    absolute
    bottom
    app
    temporary
  >
    <v-list
      nav
      dense
    >
      <v-list-item>
        <v-list-item-icon>
          <v-avatar size="24">
            <v-img :src="currentUserImage" />
          </v-avatar>
        </v-list-item-icon>
        <v-list-item-title>
          {{ displayName }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="goToUserProfile">
        <v-list-item-icon>
          <w-icon size="24">
            $wSettings
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Common.profile') + '/' + $t('Common.settings') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="showDeputyModal">
        <v-list-item-icon>
          <w-icon size="24">
            $wDeputy
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title v-if="deputyExists">
          {{
            $t('Deputies.change')
          }}
        </v-list-item-title>
        <v-list-item-title v-else>
          {{
            $t('Deputies.login')
          }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="deputyExists"
        @click="logoutAsDeputy"
      >
        <v-list-item-icon>
          <w-icon size="24">
            $wLogout
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Deputies.logout') }}</v-list-item-title>
      </v-list-item>

      <v-divider />

      <v-list-item
        v-if="$isMobileDevice()"
        @click="goToComponent('StockMovementsMobile')"
      >
        <v-list-item-icon>
          <w-icon size="24">
            $wStock
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Components.sentences.captureStockMovement') }}</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$isMobileDevice()"
        @click="invokeQrScan"
      >
        <v-list-item-icon>
          <w-icon size="24">
            $wQrCode
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('MobileDeviceBridge.sentences.readQrCode') }}</v-list-item-title>
      </v-list-item>

      <v-list-item 
        v-if="showDashboard"
        @click="goToDashboard"
      >
        <v-list-item-icon>
          <w-icon size="24">
            $wDashboard
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Common.dashboard') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="goToNavigation">
        <v-list-item-icon>
          <w-icon size="24">
            $wModuleOverview
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Common.toNavigation') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="goToOpenWindows">
        <v-list-item-icon>
          <WorkHeaderOpenWindowsBadge/>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Components.sentences.toActiveWindows') }}</v-list-item-title>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon @click="goToComponent('NotificationsOverview')">
          <w-icon size="24">
            $wNotification
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Common.notifications') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="invokeOpenHelpMenu">
        <v-list-item-icon>
          <w-icon size="24">
            $wHelp
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Common.help') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="invokeChangeInstance">
        <v-list-item-icon>
          <w-icon size="24">
            $wMobilePhone
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Components.sentences.changeInstance') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="logout">
        <v-list-item-icon>
          <w-icon size="24">
            $wLogout
          </w-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t('Common.logout') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
//components
import WorkHeaderOpenWindowsBadge from './components/WorkHeaderOpenWindowsBadge';
//helpers
import { mapState, mapActions, mapGetters } from 'vuex';
//mixins
import qrScanMixin from '@/mixins/mobile_wrapper/qr-scan-mixin';
import openHelpMenuMixin from "@/mixins/mobile_wrapper/open-help-menu-mixin";
import changeInstanceMixin from "@/mixins/mobile_wrapper/change-instance-mixin";
import { useQrScannerAndOpenUrl } from '@/composables/mobile_wrapper/qrScannerAndOpenUrl';

const DEFAULT_IMAGE = require('@/assets/upload/default_profil_image.jpg');

export default {
  name: 'WorkMobileHeaderMenu',
  components: {
    WorkHeaderOpenWindowsBadge,
  },
  setup() {
    const { handleQrScan } = useQrScannerAndOpenUrl();
  
    return { handleQrScan }
  },
  mixins: [
    qrScanMixin((self) => self.handleQrScan),
    openHelpMenuMixin,
    changeInstanceMixin
  ],
  props: {
    showDashboard: { type: Boolean, default: true },
    // Go To
    goToDashboard: { type: Function, required: true },
    goToNavigation: { type: Function, required: true },
    goToOpenWindows: { type: Function, required: true },
    // Settings
    goToUserProfile: { type: Function, required: true },
    // Acting User
    showDeputyModal: { type: Function, required: true },
    logoutAsDeputy: { type: Function, required: true },
    // data
    deputyExists: { type: Number },
    // logout
    logout: { type: Function, required: true },
  },
  computed: {
    ...mapState('actingUser', ['actingUserDetails']),
    ...mapGetters('navigationDrawer', ['isNavigationDrawerVisible', 'isNavigationDrawerOpen']),
    drawer: {
      get(){
        return this.isNavigationDrawerOpen
      },
      set(value) {
        this.setNavigationDrawerIsOpen(value)
      }
    },
    currentUserImage(){
      return this.actingUserDetails?.imgSrc ?? DEFAULT_IMAGE
    },
    displayName() {
      let displayName = this.actingUserDetails.fullname;
      if (!displayName) {
        displayName = this.actingUserDetails.username;
      }
      return `${displayName}${this.deputyExists ? ` (${this.$t('Common.deputy')})` : ''}`;
    },
  },
  methods: {
    ...mapActions('navigationDrawer', ['setNavigationDrawerIsOpen']),
    openNavigationDrawer(){
      this.setNavigationDrawerIsOpen(!this.isNavigationDrawerOpen);
    },
    goToComponent(component) {
      this.$router.push({ 
        name: component
      }).catch(() => {});
    },
  }
}
</script>

<style lang="scss" scoped>
.work-navigation-drawer {
    height: auto !important;
    max-height: 100vh;
    background-color: $navigation-bg-color;
    position: fixed;

    .v-list-item {
      cursor: pointer;
      &__title {
        color: $input-label-color;
      }
    }

    .v-list-item:hover {
      background-color: var(--v-default-lighten3);
    }
  }
</style>